import { render } from "./MultiForm.vue?vue&type=template&id=2cda5ce4&scoped=true"
import script from "./MultiForm.vue?vue&type=script&lang=js"
export * from "./MultiForm.vue?vue&type=script&lang=js"

import "./MultiForm.vue?vue&type=style&index=0&id=2cda5ce4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cda5ce4"]])

export default __exports__